<template>
  <section class="section">
    <div class="container">
      <div class="about-grid">
        <div class="about-cards">
          <article
            v-for="(card, i) in ABOUT_CARDS"
            :key="i"
            class="dark-card about-card reveal"
            :class="`reveal-delay-${i + 1}`"
          >
            <span class="about-card__number">{{ card.number }}.</span>
            <h3 class="heading-md about-card__title">{{ card.title }}</h3>
            <p class="body-sm">{{ card.description }}</p>
          </article>
        </div>

        <div class="about-visual reveal reveal-delay-2">
          <div class="about-visual__ring" aria-hidden="true"></div>

          <div class="about-visual__circle-clip">
            <img
              :src="SITE.profilePhoto"
              :alt="`${SITE.name} profile photo`"
              class="about-visual__photo"
            />
          </div>

          <div class="about-visual__shape about-visual__shape--1" aria-hidden="true"></div>
          <div class="about-visual__shape about-visual__shape--2" aria-hidden="true"></div>
          <div class="about-visual__shape about-visual__shape--3" aria-hidden="true"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ABOUT_CARDS, SITE } from "@/constants/site";
import { useScrollReveal } from "@/composables/useScrollReveal";

useScrollReveal();
</script>

<style scoped>
.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

@media (min-width: 960px) {
  .about-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
  }
}

.about-cards {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.about-card {
  padding: 1.75rem 2rem;
}

.about-card__number {
  display: block;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--color-accent);
  margin-bottom: 0.75rem;
}

.about-card__title {
  margin-bottom: 0.625rem;
}

.about-visual {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 420px;
  width: min(360px, 90vw);
  height: min(360px, 90vw);
  margin: 0 auto;
}

.about-visual__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid #333333;
  background: transparent;
  z-index: 1;
}

.about-visual__circle-clip {
  position: absolute;
  inset: 8px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
}

.about-visual__shape {
  position: absolute;
  border-radius: 50%;
  z-index: 3;
  pointer-events: none;
}

.about-visual__shape--1 {
  width: 56px;
  height: 56px;
  background: var(--color-accent);
  top: 6%;
  right: -2%;
}

.about-visual__shape--2 {
  width: 88px;
  height: 88px;
  border: 2px solid var(--color-accent);
  bottom: 18%;
  left: -6%;
  background: transparent;
}

.about-visual__shape--3 {
  width: 44px;
  height: 44px;
  background: var(--color-accent);
  bottom: 6%;
  right: 8%;
  clip-path: inset(0 0 50% 0);
  border-radius: 44px 44px 0 0;
}

.about-visual__photo {
  width: 88%;
  height: 88%;
  object-fit: contain;
  object-position: center bottom;
  display: block;
}
</style>
